"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var theme = (0, _styles.createMuiTheme)({
  breakpoints: {
    values: {
      xs: 0,
      s: 320,
      sm: 680,
      md: 768,
      lg: 992,
      xl: 1200
    }
  },
  typography: {
    body1: {
      color: '#5c5c5c'
    }
  },
  palette: {
    background: {
      default: '#f0f0f0',
      main: '#dee9f2',
      card: 'rgba(0,0,0,0.5)',
      paper: '#fff',
      paperHighlighted: 'rgba(255, 255, 255, 0.8)',
      paperHighlightedPlus: 'rgba(255, 255, 255, 0.5)'
    },
    txt: {
      main: 'rgb(92, 92, 92)',
      secondary: 'rgba(0,0,0,0.5)',
      muted: '#6c757d'
    },
    primary: {
      main: '#216aa7',
      dark: '#154a77',
      lightAction: '#E9F0F6'
    },
    secondary: {
      main: '#F46732',
      lightAction: '#FEF0EB'
    },
    error: {
      main: '#FA3232',
      lightAction: '#FFEBEB'
    },
    valid: {
      main: '#16aa62'
    },
    warning: {
      main: '#D54117'
    },
    disabled: {
      main: '#C7D9E9'
    },
    divider: '#f0f0f0'
  },
  shape: {
    borderRadius: 10
  }
});
var _default = theme;
exports.default = _default;